import React from "react";

export const Toggle = ({ on, onClick, testid }) => (
  <button data-testid={testid} onClick={onClick} aria-pressed={on}
    className={`relative w-11 h-6 rounded-full transition-colors shrink-0 ${on ? "bg-[#E6B04E]" : "bg-[#252A3B]"}`}>
    <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform ${on ? "translate-x-5" : ""}`} />
  </button>
);

export const ToggleRow = ({ label, desc, on, onClick, testid }) => (
  <div className="flex items-center justify-between gap-4">
    <div>
      <div className="font-semibold text-sm">{label}</div>
      {desc && <p className="text-[#64748B] text-xs">{desc}</p>}
    </div>
    <Toggle on={on} onClick={onClick} testid={testid} />
  </div>
);

export const Slider = ({ label, value, min = -1, max = 1, step = 0.05, onChange, onCommit, testid, fmt }) => (
  <div>
    <div className="flex items-center justify-between mb-1">
      <span className="metric-label">{label}</span>
      <span className="font-mono text-xs text-[#E6B04E]" data-testid={`${testid}-value`}>{fmt ? fmt(value) : value.toFixed(2)}</span>
    </div>
    <input type="range" min={min} max={max} step={step} value={value} data-testid={testid}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      onMouseUp={(e) => onCommit && onCommit(parseFloat(e.target.value))}
      onTouchEnd={(e) => onCommit && onCommit(parseFloat(e.target.value))}
      onKeyUp={(e) => onCommit && onCommit(parseFloat(e.target.value))}
      className="w-full accent-[#E6B04E]" />
  </div>
);

export const PageHeader = ({ icon: Icon, title, subtitle, children }) => (
  <div className="flex items-center justify-between gap-4 flex-wrap">
    <div className="flex items-center gap-3">
      <div className="w-11 h-11 rounded-xl bg-[#212534] flex items-center justify-center"><Icon size={22} className="text-[#E6B04E]" /></div>
      <div>
        <h1 className="font-head text-3xl font-extrabold tracking-tight">{title}</h1>
        <p className="text-[#94A3B8] text-sm">{subtitle}</p>
      </div>
    </div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
);
